import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Contact/Get`)
          .then(response => {
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = '',
              sortDesc = false,
              status,
              plan,
            } = queryParams

            let dataFromAPI = response.data.data

            if (status) {
              dataFromAPI = dataFromAPI.filter(user => user.active == (status == 'active'))
            }
            // contactType
            if (plan) {
              dataFromAPI = dataFromAPI.filter(user => user.contactType == plan)
            }

            /*
          if (q && q.length > 2) {
            dataFromAPI = dataFromAPI.filter(user => user.contactName.includes(q))
          }

          const filteredData = dataFromAPI.filter(
            user =>
              user.contactName
          )
          */

            if (q !== '' && q !== null) {
              const queryLowered = q.toLowerCase()
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                const contactNo = x.contactNo || ''
                const fullName = x.fullName || ''
                const phone = x.phone || ''
                const email = x.email || ''

                if (contactNo.toString().toLowerCase().includes(queryLowered)
              || fullName.toString().toLowerCase().includes(queryLowered)
              || phone.toString().toLowerCase().includes(queryLowered)
              || email.toString().toLowerCase().includes(queryLowered)
                ) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }

            const sortedData = dataFromAPI.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()

            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: dataFromAPI.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Contact/GetById`, {
            params: {
              contactId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      console.log('UserData', userData)
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/User/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteUser(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Contact/Delete`, {
            params: {
              contactId: id,
              status,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
